import type { UseQueryResult } from '@tanstack/react-query';
import { useBopisStore } from '../../hooks/useBopisStore';
import { useSDDStore } from '../../hooks/useSDDStore';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { isBasketEmpty } from '../utils/basket-utils';
import { useBasket } from './useBasket';
import type { HookProps } from '../../hooks/model/HookProps';
import type { BasketsInventory } from './model/BasketInventory';

/**
 * @returns All inventories (ship to and store inventories) for all products in the basket.
 */
export const useBasketInventory = (props?: HookProps): UseQueryResult<BasketsInventory> => {
    const { data } = useBasket();
    const { data: sddStore, isFetching: isSDDStoreFetching } = useSDDStore(props);
    const { data: bopisStore, isFetching: isBopisStoreFetching } = useBopisStore(props);

    const enabled = !isBasketEmpty(data) && !isSDDStoreFetching && !isBopisStoreFetching;

    return useBffGet<BasketsInventory>(
        `/baskets/${data?.basketId}/inventory`,
        [
            {
                bopisStoreId: bopisStore?.id ?? '',
                sddStoreId: sddStore?.id ?? '',
            },
        ],
        [
            BffQueryKey.BASKET_INVENTORY,
            String(data?.basketId),
            String(bopisStore?.id),
            String(sddStore?.id),
        ],
        {
            enabled,
            basketCustomerId: data?.customerInfo?.customerId,
            keepPreviousData: true,
            refetchOnWindowFocus: true,
        },
    );
};
